import React  from 'react';
import './App.css';
import data from './content/Jobs.json';
import JobListing from './components/JobListing'
import {BsGlobe} from 'react-icons/bs';
import {FaLinkedinIn, FaTwitter, } from 'react-icons/fa';
import logo from './assets/phoenix-logo-small.png'


function Jobs() {
  // setHidden(document.documentElement.scrollTop > 1100); 
  console.log(5);
    

  return (
    <div className="App">
      <div className="jobs-landing">
        <img src={data.Landing.logo} className="about-landing-logo"/>
        <p className="about-landing-title"> {data.Landing.title} </p>
        <p className="about-landing-text">{data.Landing.text}</p>
      </div>

      <div className="jobs">
        <div className="jobs-wrapper">
          {data.jobs.length === 0 && <p>Check back soon for openings!</p>}
          {
            data.jobs.map((job, idx) => (
              <JobListing
              company={job.company}
              position={job.position}
              description={job.description}
              logo={job.logo}
              link={job.link}
              />
            ))
          }
        </div>
      </div>


    </div>
  );
}

export default Jobs;
